import { Box, Button, ButtonProps, Typography } from '@mui/material';
import { useIsMobile } from '../hooks';
import { chevronLeftIcon } from '../config/icons';

export type BackButtonProps = Omit<ButtonProps, 'type'> & {
  type?: 'link' | 'button';
  label?: string;
  href?: string;
  logo?: string;
  hasBorder?: boolean;
  isMobile?: boolean;
};

export function BackButton({ href, label, logo, hasBorder = true, sx, ...props }: BackButtonProps) {
  const hasLabel = !!label;
  const isMobile = useIsMobile();

  return (
    <Button
      component={!!href ? 'a' : Button}
      href={href}
      variant="outlined"
      size={isMobile ? 'small' : 'large'}
      data-treedistestid="button-back-navigation"
      sx={{
        color: 'grey.800',
        display: 'flex',
        gap: '5px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        border: hasBorder ? undefined : 'none',
        boxShadow: hasBorder ? undefined : 'none',
        borderRadius: '8px',
        ...(isMobile && { height: '34px' }),
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          height: '100%',
          '& svg': {
            height: '100%',
          },
          '&:dir(rtl)': {
            transform: 'rotate(180deg)',
          },
        }}
      >
        {chevronLeftIcon}
      </Box>
      {hasLabel && (
        <Typography sx={{ paddingInlineEnd: '8px' }} fontWeight={500}>
          {label}
        </Typography>
      )}
      {logo && <img src={logo} style={{ paddingInlineEnd: '8px', height: '22px' }} alt="logo" />}
    </Button>
  );
}
